import * as moment from 'vendors/moment-locale-th';
import * as Cookies from 'js-cookie/src/js.cookie.js';
import { Injectable } from '@angular/core';
import { LANG_EN_TRANS } from '../../../translation/lang-en';
import { LANG_TH_TRANS } from '../../../translation/lang-th';
import { Language } from 'app/model/constant';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { domain, imgUrl, prefixCookieName } from "environments/properties";
import { Option } from 'app/model/dropdown/dropdown-option-model';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class AppConfigService {
  public static userInfoCookieName;
  public static tokenCookieName;
  public static publicKeyCookieName;
  public static featureCookieName;
  public static featureCompanyCookieName;
  public static checkoutDataCookieName;
  public static localStorageSearchHistoryName;
  public static notifyDisabledCookieName;
  public static bannerClosedCookieName;
  public static ssoTokenCookieName;
  public static stateCookieName;
  public static stateAffCookieName;
  public static codeChallengeCookieName;
  public static codeVerifierCookieName;
  public static coBookerCookieName;
  public static shareBudgetCodeCookieName;
  public static lat
  public static lon
  public static languageCookieName;
  public static currencyCookieName;
  public static readonly returnUrllocalStorageName = 'RETURN_URL';
  private langSubject = new Subject<any>();
  private readonly currencyId = '1';
  private readonly momentUtcOffset = '+0700';
  private readonly dateUrlFormat = `DD-MM-YYYY`;
  public readonly dateAPIFormat = `YYYY-MM-DD`;
  public readonly dateHumanFormat = `DD-MM-YYYY`;
  public readonly dateCancellationPolicyFormat = `D MMM YY`;
  public readonly dateTravelPolicyFormat = `dd D MMM YY`;
  public readonly defaultProductImage = `https://images.ascendtravel.com/NoImage.jpg`;
  public readonly vat = 7;
  public readonly ACT_LOGO_DEFAULT = 'assets/images/header/ota_logo.png';
  public readonly ACT_LOGO_DEFAULT_WHITE = 'assets/images/header/ota_logo_w.png';
  public readonly ACT_LOGO_DEFAULT_MOBILE = 'assets/images/header/ota_logo_m.png';
  public ActLogoPath = this.ACT_LOGO_DEFAULT;
  public ActLogoWhitePath = this.ACT_LOGO_DEFAULT_WHITE;
  public ActLogoMobilePath = this.ACT_LOGO_DEFAULT_MOBILE;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    AppConfigService.userInfoCookieName = `${prefixCookieName}_stf`;
    AppConfigService.tokenCookieName = `${prefixCookieName}_tk`;
    AppConfigService.publicKeyCookieName = `${prefixCookieName}_pk`;
    AppConfigService.featureCookieName = `${prefixCookieName}_ft`;
    AppConfigService.featureCompanyCookieName = `${prefixCookieName}_cft`;
    AppConfigService.checkoutDataCookieName = `${prefixCookieName}_ck`;
    AppConfigService.localStorageSearchHistoryName = `${prefixCookieName}_RECENT_SEARCHES`;
    AppConfigService.notifyDisabledCookieName = `${prefixCookieName}_nd`;
    AppConfigService.bannerClosedCookieName = `${prefixCookieName}_banner_closed`;
    AppConfigService.ssoTokenCookieName = `sso`;
    AppConfigService.stateCookieName = `${prefixCookieName}_stc`;
    AppConfigService.stateAffCookieName = `${prefixCookieName}_affstc`;
    AppConfigService.codeChallengeCookieName = `${prefixCookieName}_ccc`;
    AppConfigService.codeVerifierCookieName = `${prefixCookieName}_cvc`;
    AppConfigService.coBookerCookieName = `${prefixCookieName}_cbc`;
    AppConfigService.shareBudgetCodeCookieName = `${prefixCookieName}_sbc`;
    AppConfigService.languageCookieName = `${prefixCookieName}_lang`;
    AppConfigService.lat = `${prefixCookieName}_lat`;
    AppConfigService.lon = `${prefixCookieName}_lon`;
    AppConfigService.currencyCookieName = `${prefixCookieName}_currency`;
  }

  setLanguage(use: string) {
    this.insertParam('lang', use);
    Cookies.set(AppConfigService.languageCookieName, use, { domain: domain });
    this.langSubject.next(use);
  }

  getLanguage(): string {
    const languageCookie = this.getLanguageFromCookie();
    if (languageCookie && this.isValidLanguage(languageCookie)) {
      return languageCookie
    }

    const languageParam = this.activatedRoute.snapshot.queryParams['lang'];
    if (languageParam && this.isValidLanguage(languageParam)) {
      return languageParam;
    }

    return Language.en;
  }

  isValidLanguage(language: string) {
    return language == Language.en || language == Language.th;
  }

  getLanguageFromCookie(): string {
    return Cookies.get(AppConfigService.languageCookieName);
  }

  getLanguageId(): string {
    return this.getLanguage() === Language.en ? `1` : `2`;
  }

  getLanguageObs(): Observable<any> {
    return this.langSubject.asObservable();
  }

  getLanguageList(): Option[] {
    return [
      {
        name: 'thai',
        displayValue: 'ไทย',
        value: 'th',
        icon: 'assets/images/header/header_flag_th_2x.png',
        error: undefined
      },
      {
        name: 'english',
        displayValue: 'English',
        value: 'en',
        icon: 'assets/images/header/header_flag_en_2x.png',
        error: undefined
      }
    ];
  }

  getTranslate(keyLangTranslate): string {
    return this.getTranslateWithLang(keyLangTranslate, this.getLanguage());
  }

  getTranslateWithLang(keyLangTranslate, lang: Language): string {
    switch (lang) {
      case Language.th:
        return LANG_TH_TRANS[keyLangTranslate];
      case Language.en:
        return LANG_EN_TRANS[keyLangTranslate];
    }
  }

  getTimeForAuthorizationHeader(): string {
    return moment().utcOffset(this.momentUtcOffset).format('YYYY-MM-DD-HH-mm-ss');
  }

  getDateUrlFormat() {
    return this.dateUrlFormat;
  }

  getCurrencyId() {
    return this.currencyId;
  }

  insertParam(paramName, paramValue) {
    var url = window.location.href;
    var hash = location.hash;
    url = url.replace(hash, '');
    if (url.indexOf(paramName + "=") >= 0) {
      var prefix = url.substring(0, url.indexOf(paramName));
      var suffix = url.substring(url.indexOf(paramName));
      suffix = suffix.substring(suffix.indexOf("=") + 1);
      suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
      url = prefix + paramName + "=" + paramValue + suffix;
    }
    else {
      if (url.indexOf("?") < 0)
        url += "?" + paramName + "=" + paramValue;
      else
        url += "&" + paramName + "=" + paramValue;
    }

    const _pathName = document.location.pathname;
    history.replaceState({}, _pathName, url + hash);
  }

  getActDefaultLogoPath() {
    return {
      ActDefaultLogoPath: this.ACT_LOGO_DEFAULT,
      ActDefaultLogoWhitePath: this.ACT_LOGO_DEFAULT_WHITE,
      ActDefaultLogoMobilePath: this.ACT_LOGO_DEFAULT_MOBILE
    };
  }

  getActLogoPath() {
    return {
      ActLogoPath: this.ActLogoPath,
      ActLogoWhitePath: this.ActLogoWhitePath,
      ActLogoMobilePath: this.ActLogoMobilePath
    };
  }

  setAffiliateLogo(partnerName: string) {
    if (partnerName) {
      this.ActLogoPath = `${imgUrl}/partner-logo/${partnerName}.png`;
      this.ActLogoWhitePath = `${imgUrl}/partner-logo/${partnerName}-w.png`;
      this.ActLogoMobilePath = `${imgUrl}/partner-logo/${partnerName}.png`;
    }
  }

  getReturnUrl(): string {
    return localStorage.getItem(AppConfigService.returnUrllocalStorageName);
  }

  setReturnUrl(returnUrl: string) {
    localStorage.setItem(AppConfigService.returnUrllocalStorageName, returnUrl);
  }

  removeReturnUrlCookie() {
    localStorage.removeItem(AppConfigService.returnUrllocalStorageName);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/app-config/app-config.service.ts